// extracted by mini-css-extract-plugin
module.exports = {"container":"_61cc05a7c9--container--2J65G","img":"_61cc05a7c9--img--tUvKT","title":"_61cc05a7c9--title--1oF-C","text":"_61cc05a7c9--text--2oR31"};